import { render, staticRenderFns } from "./MatterProfessionalInvestigationForm.vue?vue&type=template&id=1f725d79&"
import script from "./MatterProfessionalInvestigationForm.vue?vue&type=script&lang=js&"
export * from "./MatterProfessionalInvestigationForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterProfessionalInvestigationForm.vue?vue&type=style&index=0&id=1f725d79&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports